// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"Modal_modalRoot__2I86R","modal":"Modal_modal__1UyVv","modalLeave":"Modal_modalLeave__1hPpk","buttonsLeave":"Modal_buttonsLeave__2dXdS"};